export enum BookingSourceEnum {
	App = 1,
	X4b = 2,
	WalkIn = 3
}
